import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Validators } from '../../common/forms';
import {ConversionFactor} from '../models';
import {DateTimeHelper} from '../../common/helpers/datetime/datetime.helper';
import moment, { Moment } from 'moment';

export function tenderAnalyticsConversionFactorForm(form: ConversionFactor): UntypedFormGroup {

    return new UntypedFormGroup({
        'is_exchange_rate_fixed': new UntypedFormControl(form.isExchangeRateFixed, [Validators.required]),
        'exchange_rate_date': new UntypedFormControl(form.exchangeRateDate ?
            DateTimeHelper.changeToYMDFormat(form.exchangeRateDate) : null, []),
        'currency_id': new UntypedFormControl(form.currency ? form.currency.id : null),
        'units_id': new UntypedFormControl(form.units ? form.units.id : null),
        'unit_conversion': new UntypedFormControl(form.unitConversion ? form.unitConversion : null),
    });
}
